import { defineStore } from 'pinia';
import { crmmApi } from 'dashboard/helper/crmmApi';
export const useWaitlistStore = defineStore('crmmWaitlist', {
  state: () => ({ items: [], loading: false }),
  actions: {
    async load() { this.loading = true; try { this.items = (await crmmApi('waitlist-list', {})) || []; } finally { this.loading = false; } },
    async add(payload) { await crmmApi('waitlist-add', payload); await this.load(); },
    async remove(id) { await crmmApi('waitlist-remove', { id }); await this.load(); },
    async update(id, payload) { await crmmApi('waitlist-update', { id, ...payload }); await this.load(); },
    async opcoes() { return (await crmmApi('waitlist-opcoes', {})) || { services: [], agendas: [] }; },
    async slots(service_id, agenda_id, janela_inicio, janela_fim) { return (await crmmApi('consultar-disponibilidade', { service_id, agenda_id, janela_inicio, janela_fim })) || { slots: [] }; },
    async criarAgendamento(payload) { return await crmmApi('criar-agendamento', payload); },
    async marcarAgendado(id) { await crmmApi('waitlist-agendado', { id }); await this.load(); },
    async reorder(id, dir) { await crmmApi('waitlist-reorder', { id, dir }); await this.load(); },
    async events() { return (await crmmApi('waitlist-events', {})) || []; },
  },
});
